export const FILTER_CLOUDINARY_FOLDER = "filters";

export function filterIconPublicId(attributeCode: string, valueCode: string): string {
  return `${FILTER_CLOUDINARY_FOLDER}/${attributeCode}/${valueCode}`;
}

/**
 * Cloudinary serves a versionless URL with `max-age=31536000`, so a replaced or deleted icon keeps
 * being served from cache for a year. A version segment makes the URL a new cache key for the
 * browser, the CDN and the Next image optimiser alike, so the icon changes when the asset does.
 * Cloudinary ignores the version when resolving the asset and always returns the current one, so
 * any rotating value works — here the mapping document's revision, which the filter sync rewrites
 * on every run. The cost is that every icon re-downloads once per sync cycle, changed or not.
 */
export function filterIconUrl(
  attributeCode: string,
  valueCode: string,
  mappingRevision?: string | number,
): string | null {
  if (!attributeCode || !valueCode) return null;
  const host = process.env.NEXT_PUBLIC_CLOUDINARY_SECURE_DISTRIBUTION;
  if (!host) return null;
  // Sanity's `_updatedAt` is an ISO timestamp; Cloudinary only accepts digits after the `v`.
  const digits = mappingRevision ? String(mappingRevision).replace(/\D/g, "") : "";
  const revision = digits ? `v${digits}/` : "";
  return `https://${host}/image/upload/f_auto,q_auto/${revision}${filterIconPublicId(attributeCode, valueCode)}`;
}
